export const OrganisationsEndpoint = {
    organization: `${process.env.API_BACKEND}/v1/organizations/organization/`,
} as const
